import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider as ThemeProviderVendor } from 'styled-components';
import { createTheme } from './utils';
import colors from './colors';

var ThemeProvider = function ThemeProvider(_a) {
  var children = _a.children,
      theme = _a.theme,
      type = _a.type;
  return _jsx(ThemeProviderVendor, __assign({
    theme: theme || createTheme(type, colors)
  }, {
    children: children
  }));
};

export default ThemeProvider;